<template>
    <div>
        <notification-modal v-model:is-error-modal="reportModalError" v-model:is-open="showReportModal">
            <template #title-content>
                {{ modalTitle }}
            </template>

            {{ modalMessage }}
        </notification-modal>

        <group-report-template v-model:current-report-template-id="currentReportTemplateId"
                               v-model:display-section="displaySection"
                               v-model:for-group="forGroup"
                               v-model:interval="$data._interval"
                               v-model:ran-report="$data._reportSuccessfullySent"
                               v-model:reload-data="$data._reloadTable"
                               v-model:running-errors="$data._errorSending"
                               v-model:running-report="$data._runningReport"
                               v-model:settings="$data._settings"
                               :can-edit="permissions.can('manage_excursion_report')"
                               :default-settings="defaultSettings"
                               :prepare-settings-function="$data._prepareSettingsFunction"
                               :show-save-button="false"
                               report-name="mkt-report"
                               @useStandardReporting="setUseStandardReporting"
        >

            <template #run-options="props">
                <h3 class="text-left text-lg font-semibold">Mean Kinetic Temperature (MKT) Report</h3>
                <div    v-if="! isSavable"
                        class="mb-4 lg:mb-2">
                    <p>
                        <b>MKT Calculation.</b> This report gives you a listing of selected points of monitoring with
                        the
                        calculate MKT for the time frame selected along with the current high and low alarm thresholds.
                    </p>

                    <p>
                        <b>MKT Detailed.</b> This report gives you a graph of each selected point of monitoring that
                        reflects
                        the daily high and low readings with the calculated MKT for the time frame selected.
                        Each point of Monitoring's details will be listed at the top of the report.
                    </p>
                    <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                        <label for="report_variation_type"></label>
                        <select2 id="report_type"
                                 v-model:value="reportType"
                                 :allow-clear="false"
                                 :close-on-select="true"
                                 :multiple="false"
                                 :options="reportTypeOptionsInput"
                                 :side-by-side="true"
                        ></select2>
                    </div>
                </div>
                <meter-interval-selection v-model:end-date="$data._endDate"
                                          v-model:end-of-interval="month"
                                          v-model:selected-meters="$data._selectedMeters"
                                          v-model:start-date="$data._startDate"
                                          :meters="metersByGroup[props.groupId]"
                                          :use-start-end-interval="true"
                                          interval="secondly"
                                          :timezone="timezone"
                                          @run-report="runReport(currentReportTemplateId)"
                ></meter-interval-selection>
            </template>

            <template   #create-settings>
                <mkt-report-settings
                    v-model:interval="$data._interval"
                    v-model:settings="$data._settings"
                    :report-variation-options="reportTypeOptionsInput"
                    :edit-in-modal="true"
                    :is-savable="isSavable"
                ></mkt-report-settings>
            </template>

            <template   #edit-settings>
                <mkt-report-settings
                    v-model:interval="$data._interval"
                    v-model:settings="$data._settings"
                    :report-variation-options="reportTypeOptionsInput"
                    :is-savable="isSavable"
                    :edit-in-modal="true"
                ></mkt-report-settings>
            </template>
        </group-report-template>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import Select2 from "@/components/elements/select2"
import Toggle from "@/components/elements/toggle"
import DateTimePicker from "@/components/Reports/DateTimePicker";
import GroupReportTemplate from "@/components/GroupReports/GroupReportTemplate"

import axios from "axios";
import NotificationModal from "@/components/elements/NotificationModal";
import MeterIntervalSelection from "@/components/GroupReports/MeterIntervalSelection";
import MktReportSettings from "@/components/GroupReports/MktReportSettings.vue";

export default {
    name: "GroupMktReport",
    mixins: [SonicuCoreMixin],
    components: {
        MktReportSettings,
        MeterIntervalSelection, NotificationModal, DateTimePicker, GroupReportTemplate, Select2, Toggle},
    props: {
        reportQueued: {
            type: String,
            default: null,
        },
        reportTypeOptionsInput: [Object, Array],
        receiveWeekday: {
            type: Number,
            default: 1,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        meters: {
            type: Object,
            default() {
                return {}
            },
        },
        metersByGroup: {
            type: Object,
            default() {
                return {}
            }
        },
        minDate: {
            type: Date,
        },
        maxDate: {
            type: Date,
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
        timezone: String,
    },
    data() {
        return {
            month: this.maxDate,
            viewMode: 'days',
            _startDate: null,
            _endDate: null,
            format: 'MMMM DD, YYYY  HH:mm',

            isSaving: false,
            isRunning: false,

            _selectedMeters: [],
            reportType: 'NABP_REPORT_MKT_CALCULATION',

            currentReportTemplateId: null,

            showReportModal: false,
            reportModalError: false,
            modalMessage: '',
            modalTitle: '',
            isErrorModal: false,



            displaySection: null,
            _interval: this.interval,

            // Manual Run Stuff
            _templateName: '',
            _groupId: null,
            _prepareSettingsFunction: null,

            _data: [],
            _settings: this.defaultSettings,

            _reloadTable: false,
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],

            forGroup: false,
            useStandardReporting: false,
        }
    },
    created() {
    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            }

            // We need to ensure that we send the dates in a 'neutral' timezone -- otherwise we get into issues
            //   when a user is in a different timezone than the selected site.
            params['start'] = this.$data._startDate
            params['end'] = this.$data._endDate
            params['meters'] = this.$data._selectedMeters

            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/mkt-report'), params)
                .then(response => {
                    this.modalTitle = 'Report Queued'
                    this.modalMessage = 'You will receive an email when the report is prepared.'
                    this.reportModalError = false
                    this.showReportModal = true
                })
                .catch(error => {
                    this.modalTitle = 'Report Error'
                    this.modalMessage = 'Error running report, please try again later.'
                    this.reportModalError = true
                    this.showReportModal = true
                })
                .finally(() => {
                    this.$data._runningReport = false
                })

        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        },
        zeropadTime(value, length = 2) {
            if (!(value instanceof String)) {
                value = value.toString()
            }
            while (value.length < length) {
                value = '0' + value
            }
            return value
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.forGroup = false
        },
    },
    watch: {
        settings (val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
    },
    computed: {
        isSavable() {
            return this.displaySection === 'show-template' || this.useStandardReporting
        },
    },
}
</script>

<style scoped>

</style>
